import {
  CSS_MOBILE_HEIGHT,
  CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT,
  CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT,
  CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT,
  SEARCH_INPUT_HEIGHT,
} from '../constants';
import type { AppConfig } from '../models';

export interface GetMobileCssVariableParams extends Pick<AppConfig, 'showSearchOnScroll'> {
  isTopBannerVisible: boolean;
}

export const getMobileCssHeightVariable = ({ isTopBannerVisible, showSearchOnScroll }: GetMobileCssVariableParams) => {
  if (isTopBannerVisible && showSearchOnScroll) {
    return CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  if (isTopBannerVisible) {
    return CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  if (showSearchOnScroll) {
    return CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT;
  }

  return CSS_MOBILE_HEIGHT;
};

export const getSearchInputTopAttribute = ({ isTopBannerVisible, showSearchOnScroll }: GetMobileCssVariableParams) => {
  if (isTopBannerVisible && showSearchOnScroll) {
    return `calc(${CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT} - ${SEARCH_INPUT_HEIGHT}px)`;
  }
  if (showSearchOnScroll) {
    return `calc(${CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT} - ${SEARCH_INPUT_HEIGHT}px)`;
  }
  if (isTopBannerVisible) {
    return CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT;
  }

  return CSS_MOBILE_HEIGHT;
};
